import React, { useEffect, useRef } from 'react';

import * as S from './styles';
import { ScreenBlackFridayType } from 'types/ScreenBlackFridayType';

type ListProductsBlackFridayProps =
	{} & ScreenBlackFridayType['carrosselProducts'];

export default function ListProductsBlackFriday({
	products,
	title
}: ListProductsBlackFridayProps) {
	const listRef = useRef<HTMLDivElement>(null);
	const scrollSpeed = 1; // Ajuste a velocidade do scroll aqui

	//passa automaticamente para o lado o carrossel
	useEffect(() => {
		const list = listRef.current;
		if (!list) return;

		let scrollInterval: NodeJS.Timeout | null = null;

		const startScrolling = () => {
			if (scrollInterval) return;

			scrollInterval = setInterval(() => {
				if (list.scrollLeft + list.clientWidth >= list.scrollWidth) {
					list.scrollLeft = 0; // Reinicia o scroll quando chega ao final
				} else {
					list.scrollLeft += scrollSpeed;
				}
			}, 35);
		};

		const stopScrolling = () => {
			if (scrollInterval) {
				clearInterval(scrollInterval);
				scrollInterval = null;
			}
		};

		startScrolling();

		list.addEventListener('mouseenter', stopScrolling);
		list.addEventListener('mouseleave', startScrolling);

		return () => {
			stopScrolling();
			list.removeEventListener('mouseenter', stopScrolling);
			list.removeEventListener('mouseleave', startScrolling);
		};
	}, []);

	return (
		<S.container>
			<h1>{title}</h1>

			{products.length > 0 ? (
				<S.list ref={listRef}>
					{products.map((product) => (
						<S.product key={product.id}>
							<img src={product.urlImage} />
							{product.labelImage === '' ||
								(product.labelImage && <p>{product.labelImage}</p>)}
						</S.product>
					))}
				</S.list>
			) : (
				<S.noProduct>
					<p>Não há produtos </p>
				</S.noProduct>
			)}
		</S.container>
	);
}
